import { Stack, Typography } from '@mui/material';

import { type Zeitraeume } from '../../dtos';
import { formatTimeRangeForDate } from '../../utils';

type BlockungenTextStackProps = {
  readonly zeitraeume: Zeitraeume;
};

export const BlockungenTextStack = (props: BlockungenTextStackProps) => (
  <Stack spacing={1}>
    {props.zeitraeume.map(({ start, end }) => (
      <Typography key={Number(start)}>{formatTimeRangeForDate(start, end)}</Typography>
    ))}
  </Stack>
);
